import { Group, Layout, Page } from "@/comn/components";
import { useFetch, useForm, useModal, useToast } from "@/comn/hooks";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { APIS, SF_COMN_CD_MGMT_DTL_INFO, URLS } from "./services/PtliComnCdAppService";

/*
 * Register Common Code Valid Values
 * !== 공통 코드 유효 값 등록 ==!
 */
export const PTLI0404006S = (props: any) => {
    const pgeUid = "UI-PTLI-0404-006S";
    const { t } = useTranslation();
    const navigate = useNavigate();
    const modal = useModal();
    const toast = useToast();
    const { comnCd } = useParams();

    const form = {
        comnCdMgmtDtlInfo: useForm({
            defaultSchema: SF_COMN_CD_MGMT_DTL_INFO,
        }),
    };

    const fetch = {
        //  common code valid value duplicate check !== 공통 코드 유효 값 중복 체크 ==!
        getComnCdDtlInfo: useFetch({
            api: (data: any) => APIS.getComnCdDtlInfo(data),
            enabled: false,
            onSuccess: (data) => {
                if (data.comnCdDtl.content) {
                    form.comnCdMgmtDtlInfo.setError("cdVldVal", {
                        message: "msg.ptl.00679", // The same code valid value exists. !== 동일한 코드 유효 값이 존재합니다. ==!
                        type: "error",
                    });
                } else {
                    form.comnCdMgmtDtlInfo.clearErrors("cdVldVal");
                }
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00025" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
        // Save Common Code Valid Values !== 공통 코드 유효 값 저장 ==!
        saveComnCdDtl: useFetch({
            api: (data: any) => APIS.saveComnCdDtl(data),
            enabled: false,
            onSuccess: () => {
                modal.openModal({ content: "msg.com.00058" }); // Successfully inserted. !== 정상적으로 등록되었습니다. ==!
                navigate(
                    URLS.ptli0404007q +
                        "/" +
                        form.comnCdMgmtDtlInfo.getValue("comnCd") +
                        "/" +
                        form.comnCdMgmtDtlInfo.getValue("cdVldVal") +
                        "?ppup=Y",
                );
                modal.postMessage({});
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00018" }), // An error occurred. !== 에러가 발생했습니다! ==!
        }),
    };

    const handler = {
        //  common code valid value duplicate check !== 공통 코드 유효 값 중복 체크 ==!
        getComnCdDtlInfo: () => {
            const data = form.comnCdMgmtDtlInfo.getValues();
            if (data.cdVldVal) {
                fetch.getComnCdDtlInfo.fetch(data);
            } else {
                form.comnCdMgmtDtlInfo.clearErrors("cdVldVal");
            }
        },
        // Save Common Code Valid Values !== 공통 코드 유효 값 저장 ==!
        saveComnCdDtl: () => {
            if (!comnUtils.isEmpty(form.comnCdMgmtDtlInfo.errors)) {
                toast.showToast({ type: "warning", content: "msg.00002" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                return;
            }

            form.comnCdMgmtDtlInfo.handleSubmit(
                () => {
                    const data = form.comnCdMgmtDtlInfo.getValues();
                    modal.openModal({
                        content: "msg.00101", // Do you want to save ? !== 저장 하시겠습니까 ? ==!
                        onConfirm: () => {
                            fetch.saveComnCdDtl.fetch(data);
                        },
                    });
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.00002" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                },
            )();
        },
    };

    return (
        <Page
            id={pgeUid}
            title={t("T_COMN_CD_DTL_RGSR")}
            navigation={{
                base: comnEnvs.base,
                nodes: [
                    { label: "Portal" },
                    { label: "Common Module" },
                    { label: "Code Management" },
                    { path: "/comnmdle/comncd/ptli0404001q", label: "Common Code Management" },
                ],
            }}
        >
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control
                                {...form.comnCdMgmtDtlInfo.schema.comnCd}
                                defaultValue={comnCd}
                                edit={false}
                            />
                            <Group.Control
                                {...form.comnCdMgmtDtlInfo.schema.cdVldVal}
                                onBlur={() => {
                                    handler.getComnCdDtlInfo();
                                }}
                            />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control {...form.comnCdMgmtDtlInfo.schema.cdVldValNmEn} />
                            <Group.Control {...form.comnCdMgmtDtlInfo.schema.cdVldValNmTz} />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control {...form.comnCdMgmtDtlInfo.schema.cdVldValNmKo} />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control {...form.comnCdMgmtDtlInfo.schema.vldStrtDt} />
                            <Group.Control {...form.comnCdMgmtDtlInfo.schema.vldEndDt} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.comnCdMgmtDtlInfo.schema.srtngOrd} />
                            <Group.Control {...form.comnCdMgmtDtlInfo.schema.usrDefnVldVal1} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.comnCdMgmtDtlInfo.schema.usrDefnVldVal2} />
                            <Group.Control {...form.comnCdMgmtDtlInfo.schema.usrDefnVldVal3} />
                        </Group.Row>
                    </Group.Section>
                    <Group.Section>
                        <Layout>
                            <Layout.Right>
                                <Layout.Button role={"save"} onClick={handler.saveComnCdDtl} />
                            </Layout.Right>
                        </Layout>
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    );
};
